import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import arrowBackIcon from '../../assets/arrow_back.svg';

interface BackButtonProps {
  onBack?: () => void;
  label?: string;
  className?: string;
}

/**
 * Reusable Back button used across the app. Uses the shared Button styles.
 * Falls back to router history when `onBack` is not provided.
 */
const BackButton: React.FC<BackButtonProps> = ({ onBack, label = 'Back to Employee List', className = '' }) => {
  const navigate = useNavigate();

  const handle = () => {
    if (onBack) return onBack();
    navigate(-1);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handle}
      className={`text-primary-800 hover:text-primary-900 flex items-center gap-2 mb-0 px-0 ${className}`}
    >
      <img src={arrowBackIcon} alt="Back" className="w-4 h-4 mr-2" />
      <span className="font-medium">{label}</span>
    </Button>
  );
};

export default BackButton;
